import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { isEmpty } from 'lodash';

import queryString from 'query-string';

import { connect } from 'react-redux';

import { GridColumn as Column } from '@progress/kendo-react-grid';

import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import BobTable from '../../../components/BobTable';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './ExecutiveSummaryEquipmentsTable.module.css';

const ExecutiveSummaryEquipmentsTable = ({
    activeEquipmentSystemType,
    bobLoading,
    companies,
    dashboardIsCurrentTimeStamp,
    extendedColumns,
    fetchNavClients,
    fetchSingleEquipment,
    history,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavCompany,
    setNavClient,
    setNavEquipment,
    setNavSite,
    targetNavCompany,
    worstPerformingEquipment,
    worstPerformingEquipmentMeta,
    ...props
}) => {
    const [data, setData] = useState([]);
    const [isSystem, setIsSystem] = useState(false);

    useEffect(() => {
        setData(worstPerformingEquipment);
        if (!isEmpty(worstPerformingEquipment)) {
            setIsSystem(worstPerformingEquipment[0].systemId !== null);
        }
    }, [worstPerformingEquipmentMeta]);

    const entityNameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                {props.dataItem[props.field]}
            </td>
        );
    };

    const scoreCell = props => {
        let score = props.dataItem[props.field];
        if (score === 0) {
            score = 0;
        }
        else if (!score) {
            score = '';
        } else if (!Number.isInteger(score)) {
            score = score.toFixed(2);
        }
        return (
            <td className={props.className} style={props.style}>
                {score + '%'}
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td className={props.className} style={props.style}>
                <img className={classes.Icon} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/equipment';

        setNavClient({});
        setNavSite({});
        setNavEquipment({});
        setActiveNavClient({});
        setActiveNavSite({});
        setActiveNavEquipment({});

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.equipment = dataItem.equipmentId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        const options = { extendedData: true };
        await fetchSingleEquipment(queryValues, options);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}`;
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.Parent}>{`${props.dataItem.clientName} - ${props.dataItem.siteName}`}</div><div className={classes.EquipmentName}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis'}}>
                            <Link
                                to={renderNavUrl(props.dataItem)}
                                onClick={
                                    (e) => {
                                        if (!e.ctrlKey) {
                                            handleNav(props.dataItem);
                                        }
                                    }
                                }
                            >
                                {props.dataItem[props.field]}
                            </Link>
                        </div>
                    }
                />
            </td>
        );
    };

    const nameFooterCell = props => {
        return (
            <td className={props.className} colSpan={extendedColumns ? 1 : 0} style={props.style}>
                Total
            </td>
        );
    };

    const totalFooterCell = props => {
        const field = props.field || '';
        const total = data.reduce((acc, current) => acc + current[field], 0);
        let imgPath = null;

        if (props.field === 'lowFaultCount') {
            imgPath = '/assets/images/low.svg';
        } else if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }

        return (
            <td className={props.className} style={props.style}>
                {imgPath ? <img className={classes.Icon} src={imgPath} alt="" /> : null}
                {total}
            </td>
        );
    };

    const scoreFooterCell = props => {
        const field = props.field || '';
        const total = data.reduce((acc, current) => acc + current[field], 0);
        let score = 0;
        if (data.length > 0) {
            score = (total / data.length);
            if (!Number.isInteger(score)) {
                score = score.toFixed(2);
            }
        }

        return (
            <td className={props.className} style={props.style}>
                {score + '%'}
            </td>
        );
    };

    const defaultColumns = [
        {
            key:        0,
            title:      'Name',
            field:      isSystem ? 'systemName' : 'equipmentName',
            cell:       nameCell,
            footerCell: nameFooterCell,
            id:         'equipName',
            width:      !extendedColumns ? 'auto' : 250,
            show:       true 
        },
        {
            key:   6,
            title: 'Client Name',
            field: 'clientName',
            cell:  entityNameCell,
            id:    'clientName',
            width: 250,
            show:  extendedColumns
        },
        {
            key:   7,
            title: 'Site Name',
            field: 'siteName',
            cell:  entityNameCell,
            id:    'siteName',
            width: 250,
            show:  extendedColumns
        },
        {
            key:        1,
            title:      'Faults',
            field:      'totalFaultCount',
            footerCell: totalFooterCell,
            id:         'faults',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        2,
            title:      'High',
            field:      'highFaultCount',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'high',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        3,
            title:      'Medium',
            field:      'mediumFaultCount',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'medium',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        4,
            title:      'Low',
            field:      'lowFaultCount',
            cell:       priorityCell,
            footerCell: totalFooterCell,
            id:         'low',
            width:      75,
            show:       dashboardIsCurrentTimeStamp
        },
        {
            key:        5,
            title:      'Score',
            field:      isSystem ? 'systemScore' : 'equipmentScore',
            cell:       scoreCell,
            footerCell: scoreFooterCell,
            id:         'scoreCell',
            width:      80,
            show:       true
        }
    ];

    let columns = defaultColumns.filter(c => c.show).map(col => {
        return (
            <Column
                key={col.key}
                field={col.field}
                title={col.title}
                cell={col.cell}
                footerCell={col.footerCell}
                id={col.id}
                width={col.width}
            />
        );
    });

    return (
        <ExecutiveSummaryTile isLoading={isEmpty(worstPerformingEquipmentMeta) || bobLoading.includes('FetchEquipment')}>
            {isEmpty(worstPerformingEquipmentMeta) || bobLoading.includes('FetchEquipment') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <BobTable
                    altStyle={true}
                    data={data}
                    columns={columns}
                    className={classes.EquipmentGrid}
                    isPageable={false}
                    scroll={'scrollable'}
                />
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading:                   state.bob.bobLoading,
        dashboardIsCurrentTimeStamp:  state.dashboard.dashboardIsCurrentTimeStamp,
        targetNavCompany:             state.bob.targetNavCompany,
        worstPerformingEquipment:     state.executiveSummary.worstPerformingEquipment,
        worstPerformingEquipmentMeta: state.executiveSummary.worstPerformingEquipmentMeta
    };
};

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummaryEquipmentsTable));
